import React, { useState } from 'react';


const LikeDislikeComponent = ({ likeCount, dislikeCount }) => {
  const [likes, setLikes] = useState(likeCount || 0);

  const handleButtonClick = (buttonNumber) => {
    if (buttonNumber === 1) {
        if (likes === likeCount || likes === 0) {
            setLikes(likes + 1);
        } else {
            setLikes(likes - 1);
        }
        
    } 
  };

  return (
<span className="like-dislike-text">
  <text className="label-button1" onClick={() => handleButtonClick(1)}>
    LIKE ({likes})
  </text>
  
</span>
  );
};

export default LikeDislikeComponent;